export default __webpack_public_path__ + "images/23c46a00c58e4ad10032ad69cef7ea88-beer.jpg";